export const environment = {
	production: true,
	apiUrl: 'https://workflow-back-prd-zuvdd3hrya-uc.a.run.app/api/',
	googleClientID: '193707695064-klo225o8g3e5knj34dpshejgtp6af5eg.apps.googleusercontent.com'
};
